// extracted by mini-css-extract-plugin
var _1 = "ngBjVxz1hypkTWA4UoQc";
var _2 = "bG1_tf8C4Fa2jyYnkLJj";
var _3 = "AMoiLEGXh0Ritrit39BF";
var _4 = "ac1nxM9UOPQVp3ByvX4v";
var _5 = "MFWsTB_ashnfDrMDlFOA";
var _6 = "dW6UTtuTJIHlGk7hbf9E";
var _7 = "HCEWaGUugvoA8wHZAR6w";
var _8 = "RjDWmNz87eSugT5taU8w";
export { _1 as "item", _2 as "item__wide", _3 as "root", _4 as "root__wide", _5 as "tab", _6 as "tab__active", _7 as "tab__inactive", _8 as "tab__wide" }
